// extracted by mini-css-extract-plugin
export var errorIcon = "_nd-1";
export var nameLogo = "_nd-0";